exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout_from_Layout-css_1Ab {\r\n  position: static;\r\n}\r\n\r\n.page_from_Layout-css_1Dm {\r\n  padding-top: 64px\r\n}\r\n\r\n.page_from_Layout-css_1Dm.paddedBottom_from_Layout-css_ki3 {\r\n  padding-bottom: 48px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"layout": "layout_from_Layout-css_1Ab",
	"page": "page_from_Layout-css_1Dm",
	"paddedBottom": "paddedBottom_from_Layout-css_ki3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/layout/Layout.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Layout.css
// module chunks = 0